import { BookingStorage } from './BookingStorage';
import { bookingStorageVersion } from './BookingStorageVersion';
import { useSessionStorage } from '../session-storage/UseSessionStorage';
import { useEffect, useMemo } from 'react';

const storageKey = 'BookingContext';

// Earlier versions kept the whole booking — ID or passport number, contact details — in
// localStorage, with no expiry. Whatever they left on a customer's device is removed here.
function removeLegacyStorage(): void {
  try {
    window.localStorage.removeItem(storageKey);
  } catch {
    // Storage is blocked, so there is nothing of ours in it either.
  }
}

export function useBookingStorage(defaultValue: BookingStorage): [BookingStorage, (value: BookingStorage) => void] {
  const [storage, setStorage] = useSessionStorage<BookingStorage>(storageKey);

  useEffect(() => {
    removeLegacyStorage();
  }, []);

  const value = useMemo<BookingStorage>(() => {
    if (!storage || storage.storageVersion !== bookingStorageVersion) {
      setStorage(defaultValue);

      return defaultValue;
    }

    return storage;
  }, [storage, setStorage]);

  return [value, setStorage];
}
